import { Label, Text } from "@medusajs/ui"
import { Children, cloneElement, isValidElement, useId, type ReactElement, type ReactNode } from "react"

/**
 * Label + control + hint. The label is linked to the control (htmlFor/id) and
 * the hint is announced with it (aria-describedby), so clicking a label focuses
 * its field and screen readers name every input.
 */
export function Field({ label, hint, children }: { label: string; hint?: string; children: ReactNode }) {
  const auto = useId()
  const only = Children.count(children) === 1 && isValidElement(children) ? (children as ReactElement<any>) : null
  const id = only?.props.id ?? auto
  const hintId = hint ? `${id}-hint` : undefined
  const control = only
    ? cloneElement(only, { id, "aria-describedby": [only.props["aria-describedby"], hintId].filter(Boolean).join(" ") || undefined })
    : children
  return (
    <div className="flex flex-col gap-y-1.5">
      <Label size="small" weight="plus" htmlFor={only ? id : undefined}>
        {label}
      </Label>
      {control}
      {hint && (
        <Text id={hintId} size="xsmall" className="text-ui-fg-muted">
          {hint}
        </Text>
      )}
    </div>
  )
}
